import React, { useEffect, useRef, useState } from "react";
import { ContentContainer } from "../../../../../components/layout";
import { BreadCrumb } from "primereact/breadcrumb";
import {
  Textarea,
  Tooltip,
  Button,
  IconButton,
  Modal,
} from "../../../../../components/core";
import { useMutation, useQuery } from "@apollo/client";
import { LOCKER_INFO } from "../../../../../constants/graphql/locker-queries";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";
import { Strings } from "../../../../../constants/strings";
import { ADD_BEHAVIORAL_CAMPAIGN } from "../../../../../constants/graphql/settings-coin-queries";
import { REWARD_BEHAVIOR_TYPE } from "../../../settings-coins/dropdown-values";
import CustomTextArea from "../../../../../components/core/custom-text-area";
import { OrderList } from "primereact/orderlist";
import { MESSAGE_VARIABLES } from "../../../../../features/coin-campaigns/behavioral-campaign/dropdown";
import AddBehavioralMajorDetails from "./components/major-details";
import AddBehavioralCampainDetails from "./components/add-campaign-details";
import { useNavigate } from "react-router-dom";
import useSidebarStore from "../../../../../zustand/stores/sidebar-store";
import { formatDateYYYYMMDD } from "../../../../../algorithms/date";

const AddBehavioralCampaign = () => {
  // local vars
  const [old, setOldBehaviorType] = useState("");
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [deleteClicked, setDeleteClicked] = useState(false);
  const navigate = useNavigate();
  const [lockerName, setLockerName] = useState([]);
  const [operatorID, setOperatorID] = useState("");
  const [allLockersSelected, setAllLockersSelected] = useState(false);
  const [behaviorTypeLabel, setBehaviorTypeLabel] = useState("");
  const [isEditingInApp, setIsEditingInApp] = useState(false);
  const [isEditingFirstTime, setIsEditingFirstTime] = useState(false);
  const [isEditingSMS2, setIsEditingSMS2] = useState(false);
  const [variables, setVariables] = useState(MESSAGE_VARIABLES);
  const [selectedVariable, setSelectedVariable] = useState([]);
  const [changesMade, setChangesMade] = useState(false);
  const [success, setSuccess] = useState(false);
  const [behaviorParameterList, setBehaviorParamterList] = useState([]);
  const [behavioralVars, setBehavioralVars] = useState({
    campaignName: "",
    startDate: (() => {
      const d = new Date();
      d.setMonth(d.getMonth() - 6);
      return d;
    })(),
    startTime: "",
    endDate: new Date(),
    endTime: "",
    lockerId: [],
    redemptionLimit: {
      campaign: null,
      person: null,
    },
    rewardedBehavior: null,
    smsMessage1: "",
    smsMessage2: "",
    appMessage: "",
    // behavior reward is the equivalent days, weeks, months of rewarded behavior
    behaviorReward: {
      value: null,
      // set to 1 to set days by default
      behaviorRewardId: 1,
    },
    // rewardTypeStr: selectedReward.label,
    remarks: "",
  });

  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
    actions: "",
  });
  // breadcrumbs
  const home = {
    icon: "pi pi-home",
    url: `${process.env.REACT_APP_BASE_ENVIRONMENT}mbox-behavioral-campaigns`,
  };
  const breadcrumbItems = [{ label: "Add Behavioral Campaign", path: "#" }];

  // gql
  const { data: allLockerNames } = useQuery(LOCKER_INFO, {
    variables: { operatorId: operatorID },
  });
  const [createBehavioralCampaign] = useMutation(ADD_BEHAVIORAL_CAMPAIGN);

  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);
  // console.log({ operatorID });

  // console.log({ allLockerNames });

  // temporary dropdown list
  const behaviorTypeList = REWARD_BEHAVIOR_TYPE.filter((x) => x.value !== 2);

  const defaultHeaders = [
    {
      header: behaviorTypeLabel || "Reward Parameter",
      field: "parameterValue",
      // key: "params_name",
      sortable: "true",
    },
    {
      header: "MBOX Coins to be Earned",
      field: "coins_value",
      // key: "coins_value",
      sortable: "true",
    },
  ];

  const durationOptions = [
    { label: "days", value: 1 },
    { label: "weeks", value: 2 },
    { label: "months", value: 3 },
  ];

  const [openCancelModal, setOpenCancelModal] = React.useState(false);

  const convertBehaviorRewardIdToDays = (behaviorRewardId) => {
    // console.log({ behavioralVars });
    const behaviorRewardMapping = {
      1: { value: 1, unit: "days" }, // Example for 'days'
      2: { value: 2, unit: "weeks" }, // Example for 'weeks'
      3: { value: 3, unit: "months" }, // Example for 'months'
      // Add more cases as needed
    };

    const reward = behaviorRewardMapping[behaviorRewardId];
    if (!reward) {
      return 0;
    }

    switch (reward.unit) {
      case "days":
        return behavioralVars.behaviorReward.value;
      case "weeks":
        return behavioralVars.behaviorReward.value * 7;
      case "months":
        return behavioralVars.behaviorReward.value * 30;
      default:
        return 0;
    }
  };

  const [convertedToDays, setConvertedToDays] = useState(null);
  useEffect(() => {
    if (behavioralVars.behaviorReward.behaviorRewardId !== "1") {
      const days = convertBehaviorRewardIdToDays(
        behavioralVars.behaviorReward.behaviorRewardId
      );
      setConvertedToDays(days);
    }
  }, [behavioralVars]);

  useEffect(() => {
    if (pendingNavigation !== null) {
      if (changesMade) {
        setOpenCancelModal(true);
        // setValidation({
        // 	icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        // 	title: `${Strings.popup_confirm_cancel_title}?`,
        // 	message: Strings.popup_confirm_cancel_massage,
        // 	open: true,
        // 	actions: (
        // 		<div className="flex justify-between gap-3">
        // 			<Button
        // 				onClick={() => {
        // 					setValidation({ open: false });
        // 					// window.location.reload();
        // 					setPendingNavigation(null);
        // 					setActiveSubItem(activeSubItem);
        // 				}}
        // 				value={"No"}
        // 				className={"p-2 w-full"}
        // 			/>
        // 			<Button
        // 				onClick={() => {
        // 					navigate(pendingNavigation);
        // 					setPendingNavigation(null);
        // 				}}
        // 				value={"Yes"}
        // 				className={"p-2 w-full"}
        // 			/>
        // 		</div>
        // 	),
        // });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);
  // console.log({ behavioralVars });

  const handleChange = (event, rowData) => {
    const { name, value } = event.target;
    const keys = name.split(".");
    setChangesMade(true);
    if (keys.length === 2) {
      // Nested property update
      const updatedValue = value === 0 ? " " : value;
      setBehavioralVars((prevState) => ({
        ...prevState,
        [keys[0]]: {
          ...prevState[keys[0]],
          [keys[1]]: updatedValue?.toString(),
        },
      }));
    } else if (name === "parameterValue" || name === "coins_value") {
      const index = rowData.index;
      setBehaviorParamterList((prevState) => {
        const updatedList = [...prevState];
        updatedList[index] = {
          ...updatedList[index],
          [keys[0]]: value,
        };
        return updatedList;
      });
    } else {
      if (name === "rewardedBehavior") {
        setBehavioralVars((prevState) => {
          const newState = { ...prevState, [name]: value };
          if (name === "rewardedBehavior") {
            setOldBehaviorType(prevState.rewardedBehavior || "");
          }
          return newState;
        });
      } else {
        if (name === "lockerId") {
          const currentLockers = behavioralVars.lockerId || [];
          const newLockers = value;

          const isBulkRemoval =
            currentLockers.length > 0 &&
            newLockers.length < currentLockers.length &&
            newLockers.length === 0;

          if (isBulkRemoval) {
            // Show confirmation dialog
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: "Remove All Lockers?",
              message:
                "Do you want to remove all the lockers for this campaign?",
              open: true,
              actions: (
                <div className="grid grid-cols-2 gap-2">
                  <Button
                    onClick={() => {
                      setValidation((prev) => ({ ...prev, open: false }));
                      setBehavioralVars((prevState) => ({
                        ...prevState,
                        lockerId: currentLockers, // Restore original lockers
                      }));
                    }}
                    value={"No"}
                    className={"p-2"}
                  />
                  <Button
                    onClick={() => {
                      setValidation((prev) => ({ ...prev, open: false }));
                      setBehavioralVars((prevState) => ({
                        ...prevState,
                        lockerId: [],
                      }));
                    }}
                    value={"Yes"}
                    className={"p-2"}
                  />
                </div>
              ),
            });
          } else {
            setBehavioralVars((prevState) => ({
              ...prevState,
              [name]: value,
            }));
          }
        } else {
          setBehavioralVars((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
      }
    }
  };

  // console.log({ old });

  useEffect(() => {
    if (allLockerNames && allLockerNames.lockerInfo) {
      let tempData = [];

      allLockerNames.lockerInfo.forEach((element) => {
        tempData.push({
          value: element.lockerId,
          label: element.lockerName,
        });
      });

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLockerName(tempData);
    }
  }, [allLockerNames, allLockersSelected]);

  useEffect(() => {
    let opIDLocal = localStorage.getItem("user");

    let opIDLocal2 = JSON.parse(opIDLocal);

    setOperatorID(opIDLocal2.operator_id);
  }, []);

  // console.log({ operatorID });

  useEffect(() => {
    const hasZeroValue = behavioralVars.lockerId.some(
      (item) => item.value === 0
    );

    if (hasZeroValue) {
      // console.log("heyyyy");
      setAllLockersSelected(true);
    }

    if (behavioralVars.lockerId.length === 0) {
      setAllLockersSelected(false);
    }
  }, [behavioralVars.lockerId]);

  const [updatedMessagesFormat, setUpdatedMessagesFormat] = useState({
    sms_message1: "",
    sms_message2: "",
    app_message: "",
  });
  const [messagesFormat, setMessagesFormat] = useState(updatedMessagesFormat);

  useEffect(() => {
    if (
      selectedVariable.length > 0 &&
      (isEditingFirstTime || isEditingSMS2 || isEditingInApp)
    ) {
      const lastSelectedVariable =
        selectedVariable[selectedVariable.length - 1];

      setUpdatedMessagesFormat((prevState) => ({
        ...prevState,
        sms_message1:
          isEditingFirstTime && !isEditingInApp && !isEditingSMS2
            ? prevState.sms_message1 + " " + lastSelectedVariable
            : prevState.sms_message1,
        sms_message2:
          !isEditingFirstTime && !isEditingInApp && isEditingSMS2
            ? prevState.sms_message2 + " " + lastSelectedVariable
            : prevState.sms_message2,
        app_message:
          isEditingInApp && !isEditingFirstTime && !isEditingSMS2
            ? prevState.app_message + " " + lastSelectedVariable
            : prevState.app_message, // Corrected fallback
      }));
    }
  }, [selectedVariable, isEditingFirstTime, isEditingInApp, isEditingSMS2]);

  const getBehaviorTypeLabel = (value) => {
    const behavior = behaviorTypeList.find(
      (item) => item.value === parseInt(value)
    );
    return behavior ? behavior.name : "";
  };

  const [editingIndex, setEditingIndex] = useState(null);
  const actionTemplate = (rowData, index) => {
    // console.log({ rowData, options });
    setEditingIndex(index);

    return (
      <IconButton
        type="button"
        icon="pi pi-trash"
        className="bg-red-500 text-white text-center items-center"
        onClick={() => {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: "Delete Reward Parameter",
            message: "Do you want to remove this reward parameter?",
            open: true,
            actions: (
              <div className="grid grid-cols-2 gap-2">
                <Button
                  onClick={() => {
                    setValidation((prev) => ({
                      ...prev,
                      open: false,
                    }));

                    // if (!deleteClicked) {
                    // 	setBehavioralVars((prevState) => ({
                    // 		...prevState,
                    // 		behaviorType: old,
                    // 	}));
                    // }
                  }}
                  value={"No"}
                  className={"p-2"}
                />
                <Button
                  onClick={() =>
                    // onDeleteLockerAssignment(
                    // 	validation.header.event,
                    // 	validation.header.partnerBranchAssignmentId
                    // )
                    {
                      handleDeleteRow(rowData);
                      setValidation((prev) => ({
                        ...prev,
                        open: false,
                      }));

                      // setSelectedRowData(rowData);
                      // setDeleteClicked(true);
                    }
                  }
                  value={"Yes"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        }}
      />
    );
  };

  const handleAddRow = () => {
    const newRow = {
      index: behaviorParameterList.length,
      parameterValue: "",
      params_name: behavioralVars.rewardedBehavior,
      coins_value: null,
    };

    // Update behaviorParameterList
    setBehaviorParamterList((prevList) => [...prevList, newRow]);

    // // Update behavioralVars to include the new row in rewardParameter
    // setBehavioralVars((prevVars) => ({
    // 	...prevVars,
    // 	rewardParameter: [...prevVars.rewardParameter, newRow],
    // }));
  };

  const handleDeleteRow = (rowData) => {
    // Filter out the row to be deleted
    let updatedRows = behaviorParameterList.filter(
      (row) => row.index !== rowData.index
    );

    // Update the indexes of the remaining rows
    updatedRows = updatedRows.map((row, index) => ({
      ...row,
      index: index, // Reassign index
    }));

    setBehavioralVars({
      ...behavioralVars,
      rewardParameter: updatedRows,
    });

    // const another = {
    // 	...behaviorParameterList,
    // 	updatedRows,
    // };

    // console.log({ updatedRows });

    setBehaviorParamterList(updatedRows);
    // setDeleteSuccess(true);
  };

  const addButtonTemplate = () => (
    <div style={{ textAlign: "center" }} className="flex justify-center">
      <Button
        // value={
        // 	behaviorTypeLabel !== ""
        // 		? `Add ${behaviorTypeLabel}`
        // 		: "Add Reward Parameter"
        // }
        value={"Add Reward Parameter"}
        className={`p-2 mx-auto px-5 ${
          !behaviorTypeLabel ? "cursor-not-allowed" : ""
        }`}
        onClick={() => {
          handleAddRow();
        }}
        disabled={!behaviorTypeLabel}
      />
    </div>
  );

  useEffect(() => {
    if (behavioralVars.rewardedBehavior) {
      const label = getBehaviorTypeLabel(behavioralVars.rewardedBehavior);
      setBehaviorTypeLabel(label);
    }
  }, [behavioralVars.rewardedBehavior]);

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerName.filter((locker) => locker.value !== 0);

      setBehavioralVars((prevState) => ({
        ...prevState,
        lockerId: selectedLockers,
      }));

      // setLockerName([]);
    } else {
      setBehavioralVars((prevState) => ({
        ...prevState,
        lockerId: [],
      }));
    }
  }, [allLockersSelected, lockerName]);

  const prevBehaviorType = useRef(behavioralVars.rewardedBehavior);
  useEffect(() => {
    if (prevBehaviorType.current !== behavioralVars.rewardedBehavior) {
      if (behaviorParameterList.length > 0) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "You have made changes",
          message:
            "Are you sure you want to change behavior type? Your changes will not be saved.",
          open: true,
          actions: (
            <div className="grid grid-cols-2 gap-2">
              <Button
                onClick={() => {
                  setValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));

                  // if (!deleteClicked) {
                  // 	setBehavioralVars((prevState) => ({
                  // 		...prevState,
                  // 		behaviorType: old,
                  // 	}));
                  // }
                }}
                value={"No"}
                className={"p-2"}
              />
              <Button
                value={"Yes"}
                className={"p-2"}
                onClick={() => {
                  setBehaviorParamterList([]);
                  setValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));

                  // if (!deleteClicked) {
                  // 	setBehavioralVars((prevState) => ({
                  // 		...prevState,
                  // 		behaviorType: old,
                  // 	}));
                  // }
                }}
              />
            </div>
          ),
        });
      }
    }
    prevBehaviorType.current = behavioralVars.rewardedBehavior;
  }, [behavioralVars.rewardedBehavior, behaviorParameterList]);

  const validateFields = () => {
    let now = new Date();
    let phtOffset = 8 * 60;
    let currentTimePHT = new Date(
      now.getTime() + (now.getTimezoneOffset() + phtOffset) * 60000
    );

    let currentTimePlus30Minutes = new Date(
      currentTimePHT.getTime() + 30 * 60000
    );

    let startDateTime = new Date(
      `${behavioralVars.startDate}T${behavioralVars.startTime}`
    );
    let endDateTime = new Date(
      `${behavioralVars.endDate}T${behavioralVars.endTime}`
    );

    let durationInMilliseconds = endDateTime - startDateTime;

    // Convert milliseconds to days
    let durationInDays = durationInMilliseconds / (1000 * 60 * 60 * 24);

    // console.log({ convertedToDays, behavioralVars });
    // console.log({ startDateTime, endDateTime });

    if (
      behavioralVars.campaignName === "" ||
      behavioralVars.startDate === "" ||
      behavioralVars.endDate === "" ||
      behavioralVars.startTime === "" ||
      behavioralVars.endTime === "" ||
      behavioralVars.lockerId.length === 0 ||
      behavioralVars.redemptionLimit.campaign === null ||
      behavioralVars.redemptionLimit.person === null ||
      behavioralVars.rewardedBehavior === "" ||
      behaviorParameterList.length === 0 ||
      updatedMessagesFormat.sms_message1 === "" ||
      updatedMessagesFormat.sms_message2 === "" ||
      updatedMessagesFormat.app_message === ""
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Incomplete Fields",
        message: "Please fill out all the fields to proceed",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (
      new Date(behavioralVars.startDate) > new Date(behavioralVars.endDate)
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Campaign Date",
        message: "End date cannot be later than start date.",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (startDateTime < currentTimePlus30Minutes) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Campaign Start Time",
        message:
          "Start time must be at least 30 minutes from the current time.",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (startDateTime > endDateTime) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Campaign Time",
        message: "End time cannot be greater than start time on the same day.",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (startDateTime.getTime() === endDateTime.getTime()) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Campaign Time",
        message: "End time cannot be equal to start time on the same day.",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (
      behavioralVars.rewardedBehavior === "2" &&
      convertedToDays > durationInDays
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Time Frame",
        message: "Time frame is greater than campaign date",
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else {
      // 	// setShowSaveDialogOpen(true);

      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        title: Strings.popup_confirm_save_title,
        message: Strings.popup_confirm_save_massage,
        open: true,
        actions: (
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={() => {
                // console.log("why");
                handleSaveChanges();
              }}
              value={"Yes"}
              className={"p-2"}
              // disabled={
              // 	accessPermission.lockerUserType === 1 ||
              // 	accessPermission.lockerUserType === "1"
              // }
            />
          </div>
        ),
      });
    }
  };

  const handleSaveChanges = () => {
    let inputValues = [
      {
        //campaign Title
        campaignName: behavioralVars.campaignName,
        //lockerId
        lockerId: allLockersSelected ? [0] : behavioralVars.lockerId,
        //startDate
        startDateTime:
          behavioralVars.startDate + "T" + behavioralVars.startTime,
        // endDate
        endDateTime: behavioralVars.endDate + "T" + behavioralVars.endTime,

        redemptionLimit: {
          // campaignRedemptionLimit
          campaign:
            behavioralVars.redemptionLimit.campaign === " "
              ? "0"
              : behavioralVars.redemptionLimit.campaign,
          // userRedemptionLimit
          person:
            behavioralVars.redemptionLimit.person === " "
              ? "0"
              : behavioralVars.redemptionLimit.person,
        },
        //campaignBehaviorTypeNo
        rewardedBehavior: behavioralVars.rewardedBehavior,
        //campaignRedemptionLimit
        behaviorReward:
          behavioralVars.rewardedBehavior === "1"
            ? []
            : behavioralVars.behaviorReward,
        //campaignBehaviorParameters
        rewardParameter: behaviorParameterList,
        //remarks
        remarks: behavioralVars.remarks,
      },
    ];
    const stringMessages = {
      sms_message1: updatedMessagesFormat.sms_message1,
      sms_message2: updatedMessagesFormat.sms_message2,
      app_message: updatedMessagesFormat.app_message,
    };

    let finalStr = JSON.stringify(stringMessages);

    let transformedBehaviorParameterList = behaviorParameterList?.map(
      (item) => ({
        index: item.index,
        value: item.coins_value,
        seconds: item.parameterValue * 3600,
      })
    );

    let behaviorParameterString = JSON.stringify(
      transformedBehaviorParameterList
    );

    createBehavioralCampaign({
      variables: {
        id: null,
        title: behavioralVars.campaignName,
        status: 1,
        operatorId: operatorID,
        lockerIds: allLockersSelected
          ? [0]
          : behavioralVars.lockerId.map((locker) => locker.value),
        behaviorType: behavioralVars.rewardedBehavior,
        behaviorParams: behaviorParameterString,
        rewardParams: finalStr,
        rewardType: 1,
        redemptionLimit:
          behavioralVars.redemptionLimit.campaign === " "
            ? 0
            : behavioralVars.redemptionLimit.campaign,
        userLimit:
          behavioralVars.redemptionLimit.person === " "
            ? 0
            : behavioralVars.redemptionLimit.person,
        startDate: `${formatDateYYYYMMDD(behavioralVars.startDate)}T${
          behavioralVars.startTime
        }+08:00`,
        endDate: `${formatDateYYYYMMDD(behavioralVars.endDate)}T${
          behavioralVars.endTime
        }+08:00`,
        remarks: behavioralVars.remarks,
      },
    })
      .then((response) => {
        if (response) {
          const campaignID =
            response.data.upsertCampaignBehavior.campaignBehavior
              .campaignBehaviorId;
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: "Success",
            message: `Behavioral Campaign successfully created.`,
            open: true,
            actions: (
              <div className="w-full">
                <Button
                  onClick={() => {
                    setValidation({ open: false });
                    // window.location.reload();
                    navigate(
                      `/mbox-behavioral-campaigns/edit-behavioral/${campaignID}`
                    );
                  }}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }
      })
      .catch((e) => {
        console.error({ e });
      });
  };

  const itemTemplate = (variable) => {
    // console.log({ variable });
    return (
      <div className="p-flex p-ai-center">
        <div>{variable.label}</div>
      </div>
    );
  };
  return (
    <>
      <ContentContainer>
        <div className="w-full">
          <BreadCrumb
            home={home}
            model={breadcrumbItems}
            className="p-3 outline outline-1 outline-primary-primaryYellow"
          ></BreadCrumb>

          <div className="h-full w-full px-2">
            <div className="text-xl font-bold pt-3">
              New Behavioral Campaign
            </div>

            <AddBehavioralMajorDetails
              behavioralVars={behavioralVars}
              handleChange={handleChange}
              lockerName={lockerName}
            />
          </div>
          {/* divider */}
          <div className="w-full px-9">
            <Divider className=" border border-gray-200 px-11"></Divider>
          </div>
          {/* end of divider */}
          <AddBehavioralCampainDetails
            behavioralVars={behavioralVars}
            handleChange={handleChange}
            behaviorTypeList={behaviorTypeList}
            durationOptions={durationOptions}
            behaviorParameterList={behaviorParameterList}
            addButtonTemplate={addButtonTemplate}
            behaviorTypeLabel={behaviorTypeLabel}
            setChangesMade={setChangesMade}
            actionTemplate={actionTemplate}
          />
          <div className="w-full px-9">
            <Divider className=" border border-gray-200 px-11"></Divider>
          </div>
          <div>
            <Card className="bg-[#F8EED4] font-montserrat">
              <div className="px-3 w-full flex flex-col justify-center items-center pb-3">
                <div className="uppercase font-bold text-black tracking-wide text-2xl">
                  campaign message templates
                </div>
                <div className="italic font-semibold">
                  To insert a variable in the message,{" "}
                  <span className="text-red-600 underline">select</span> a
                  variable from the list.
                </div>
              </div>

              <div className="grid grid-cols-10 space-x-4">
                <div className="col-span-10">
                  <div className="grid grid-cols-12 space-x-4">
                    <Card className="col-span-7 bg-secondary-sandGrey">
                      <div className="font-bold text-black text-lg  ">
                        SMS Message Templates:
                      </div>
                      <div className=" flex flex-row w-full gap-4 h-full">
                        <Card className="w-[50%] ">
                          <div className="flex flex-col gap-2">
                            <div className="flex w-full justify-between">
                              <label>
                                <Tooltip
                                  icon2={"pi pi-question-circle"}
                                  className={"pr-1 items-center mt-0"}
                                  message={
                                    <div>
                                      <p className="indent-5">
                                        This message template will be sent to
                                        users that earned MBOX coins for the{" "}
                                        <span className="font-bold text-orange-400">
                                          first time
                                        </span>{" "}
                                        for this{" "}
                                        <span className="font-bold text-orange-400">
                                          specific campaign
                                        </span>
                                      </p>
                                    </div>
                                  }
                                ></Tooltip>
                                First Time SMS Message
                              </label>

                              <IconButton
                                icon="pi pi-pencil"
                                onClick={() => {
                                  setIsEditingFirstTime(true);
                                  setIsEditingInApp(false);
                                  setIsEditingSMS2(false);
                                  setSelectedVariable([]);
                                }}
                              ></IconButton>
                            </div>

                            <div className="w-full">
                              {updatedMessagesFormat.sms_message1?.length >
                                320 && (
                                <div className="text-red-500">
                                  Maximum character limit reached!
                                </div>
                              )}
                              <CustomTextArea
                                placeholder={
                                  "Congratulations, Juan! You have earned 3 MBOX coins for the first time. Open your MBOX Locker App to view your total MBOX coin balance. Thank you for using MBOX Smart Lockers!"
                                }
                                value={updatedMessagesFormat.sms_message1}
                                disabled={!isEditingFirstTime}
                                className={`w-full min-h-[150px] text-md ${
                                  updatedMessagesFormat.sms_message1.length >
                                  320
                                    ? "border-red-500"
                                    : ""
                                }`}
                                onChange={(e) => {
                                  const newValue = e.target.value;

                                  setUpdatedMessagesFormat({
                                    ...updatedMessagesFormat,
                                    sms_message1: newValue,
                                  });
                                }}
                                maxLength={320}
                              />
                              {isEditingFirstTime && (
                                <>
                                  <div className="flex justify-start space-x-2">
                                    <Button
                                      value={"Cancel"}
                                      className={
                                        "p-2 font-normal border bg-white border-primary-primaryYellow px-3"
                                      }
                                      onClick={() => {
                                        setValidation({
                                          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                                          title: "You have made changes",
                                          message:
                                            "Are you sure you want to stop editing the first time SMS Message? Your changes will not be saved.",
                                          open: true,
                                          actions: (
                                            <div className="grid grid-cols-2 gap-2">
                                              <Button
                                                onClick={() => {
                                                  setValidation((prev) => ({
                                                    ...prev,
                                                    open: false,
                                                  }));
                                                }}
                                                value={"No"}
                                                className={"p-2"}
                                              />
                                              <Button
                                                value={"Yes"}
                                                className={"p-2"}
                                                onClick={() => {
                                                  setValidation((prev) => ({
                                                    ...prev,
                                                    open: false,
                                                  }));

                                                  setIsEditingFirstTime(false);
                                                  setUpdatedMessagesFormat({
                                                    ...updatedMessagesFormat,
                                                    sms_message1:
                                                      messagesFormat.sms_message1,
                                                  });
                                                }}
                                              />
                                            </div>
                                          ),
                                        });
                                      }}
                                    ></Button>
                                    <Button
                                      value={"Save SMS Message"}
                                      className={"p-2 px-5"}
                                      disabled={
                                        updatedMessagesFormat.sms_message1
                                          .length > 320
                                      }
                                      onClick={() => {
                                        setIsEditingFirstTime(false);
                                        setMessagesFormat({
                                          ...messagesFormat,
                                          sms_message1:
                                            updatedMessagesFormat.sms_message1,
                                        });
                                      }}
                                    ></Button>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </Card>

                        {/* sms 2: succeeding earning message */}
                        <Card className="w-[50%]">
                          <div className="flex flex-col gap-2">
                            <div className="flex w-full justify-between">
                              <label>
                                <Tooltip
                                  icon2={"pi pi-question-circle"}
                                  className={"pr-1 items-center mt-0"}
                                  message={
                                    <div>
                                      <p className="indent-5">
                                        This message template will be sent to
                                        users for{" "}
                                        <span className="font-bold text-orange-400">
                                          every 100 MBOX coins
                                        </span>{" "}
                                        earned.
                                      </p>
                                    </div>
                                  }
                                ></Tooltip>
                                SMS Message for every 100 MBOX Coins earned
                              </label>

                              <IconButton
                                icon="pi pi-pencil"
                                onClick={() => {
                                  setIsEditingSMS2(true);
                                  setIsEditingFirstTime(false);
                                  setIsEditingInApp(false);
                                  setSelectedVariable([]);
                                }}
                              ></IconButton>
                            </div>

                            <div className="w-full">
                              {updatedMessagesFormat.sms_message2?.length >
                                320 && (
                                <div className="text-red-500">
                                  Maximum character limit reached!
                                </div>
                              )}
                              <CustomTextArea
                                placeholder={
                                  "Congratulations, Juan! You have earned 10 MBOX coins for picking up your parcel within N hours. Thank you for using MBOX Smart Lockers!"
                                }
                                disabled={!isEditingSMS2}
                                value={updatedMessagesFormat.sms_message2}
                                className={`w-full min-h-[150px] text-md ${
                                  updatedMessagesFormat.sms_message2?.length >
                                  320
                                    ? "border-red-500"
                                    : ""
                                }`}
                                onChange={(e) => {
                                  const newValue = e.target.value;

                                  setUpdatedMessagesFormat((prevState) => ({
                                    ...prevState,
                                    sms_message2: newValue,
                                  }));
                                }}
                                maxLength={320}
                              />

                              {isEditingSMS2 && (
                                <>
                                  <div className="flex justify-start space-x-2">
                                    <Button
                                      value={"Cancel"}
                                      className={
                                        "p-2 font-normal border bg-white border-primary-primaryYellow px-3"
                                      }
                                      onClick={() => {
                                        setValidation({
                                          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                                          title: "You have made changes",
                                          message:
                                            "Are you sure you want to stop editing this SMS message? Your changes will not be saved.",
                                          open: true,
                                          actions: (
                                            <div className="grid grid-cols-2 gap-2">
                                              <Button
                                                onClick={() => {
                                                  setValidation((prev) => ({
                                                    ...prev,
                                                    open: false,
                                                  }));

                                                  // if (!deleteClicked) {
                                                  // 	setBehavioralVars((prevState) => ({
                                                  // 		...prevState,
                                                  // 		behaviorType: old,
                                                  // 	}));
                                                  // }
                                                }}
                                                value={"No"}
                                                className={"p-2"}
                                              />
                                              <Button
                                                value={"Yes"}
                                                className={"p-2"}
                                                onClick={() => {
                                                  setValidation((prev) => ({
                                                    ...prev,
                                                    open: false,
                                                  }));

                                                  setIsEditingSMS2(false);
                                                  setUpdatedMessagesFormat({
                                                    ...updatedMessagesFormat,
                                                    sms_message2:
                                                      messagesFormat.sms_message2,
                                                  });
                                                }}
                                              />
                                            </div>
                                          ),
                                        });
                                      }}
                                    ></Button>
                                    <Button
                                      value={"Save SMS message"}
                                      disabled={
                                        updatedMessagesFormat.sms_message2
                                          .length > 320
                                      }
                                      className={"p-2 px-5"}
                                      onClick={() => {
                                        setIsEditingSMS2(false);
                                        setMessagesFormat({
                                          ...messagesFormat,
                                          sms_message2:
                                            updatedMessagesFormat.sms_message2,
                                        });
                                      }}
                                    ></Button>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </Card>
                      </div>
                    </Card>

                    <Card className="col-span-3 bg-secondary-sandGrey">
                      {" "}
                      <div className="font-bold text-black text-lg  ">
                        In-app Message Template:
                      </div>
                      <div className=" flex flex-row w-full gap-4">
                        <Card className="w-full">
                          <div className="flex flex-col gap-2">
                            <div className="flex w-full justify-between">
                              <label>
                                <Tooltip
                                  icon2={"pi pi-question-circle"}
                                  className={"pr-1 items-center mt-0"}
                                  message={
                                    <div>
                                      <p className="indent-5">
                                        This message template will be sent to
                                        users{" "}
                                        <span className="font-bold text-orange-400">
                                          each time they earn coins
                                        </span>{" "}
                                        for this{" "}
                                        <span className="font-bold text-orange-400">
                                          campaign
                                        </span>{" "}
                                        as long as they have the MBOX
                                        application installed on their device
                                      </p>
                                    </div>
                                  }
                                ></Tooltip>
                                In-app message for every coin earned:
                              </label>

                              <IconButton
                                icon="pi pi-pencil"
                                onClick={() => {
                                  setIsEditingInApp(true);
                                  setIsEditingFirstTime(false);
                                  setIsEditingSMS2(false);
                                  setSelectedVariable([]);
                                }}
                              ></IconButton>
                            </div>

                            <div className="w-full">
                              {updatedMessagesFormat.app_message?.length >
                                1000 && (
                                <div className="text-red-500">
                                  Maximum character limit reached!
                                </div>
                              )}
                              <CustomTextArea
                                placeholder={
                                  "Congratulations, Juan! You have earned 10 MBOX coins for picking up your parcel within N hours. Thank you for using MBOX Smart Lockers!"
                                }
                                disabled={!isEditingInApp}
                                value={updatedMessagesFormat.app_message}
                                className={`w-full min-h-[150px] text-md ${
                                  updatedMessagesFormat.app_message?.length >
                                  320
                                    ? "border-red-500"
                                    : ""
                                }`}
                                onChange={(e) => {
                                  const newValue = e.target.value;

                                  setUpdatedMessagesFormat((prevState) => ({
                                    ...prevState,
                                    app_message: newValue,
                                  }));
                                }}
                              />
                              {isEditingInApp && (
                                <>
                                  <div className="flex justify-start space-x-2">
                                    <Button
                                      value={"Cancel"}
                                      className={
                                        "p-2 font-normal border bg-white border-primary-primaryYellow px-3"
                                      }
                                      onClick={() => {
                                        setValidation({
                                          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                                          title: "You have made changes",
                                          message:
                                            "Are you sure you want to stop editing the In-App Message? Your changes will not be saved.",
                                          open: true,
                                          actions: (
                                            <div className="grid grid-cols-2 gap-2">
                                              <Button
                                                onClick={() => {
                                                  setValidation((prev) => ({
                                                    ...prev,
                                                    open: false,
                                                  }));

                                                  // if (!deleteClicked) {
                                                  // 	setBehavioralVars((prevState) => ({
                                                  // 		...prevState,
                                                  // 		behaviorType: old,
                                                  // 	}));
                                                  // }
                                                }}
                                                value={"No"}
                                                className={"p-2"}
                                              />
                                              <Button
                                                value={"Yes"}
                                                className={"p-2"}
                                                onClick={() => {
                                                  setValidation((prev) => ({
                                                    ...prev,
                                                    open: false,
                                                  }));

                                                  setIsEditingInApp(false);
                                                  setUpdatedMessagesFormat({
                                                    ...updatedMessagesFormat,
                                                    app_message:
                                                      messagesFormat.app_message,
                                                  });
                                                }}
                                              />
                                            </div>
                                          ),
                                        });
                                      }}
                                    ></Button>
                                    <Button
                                      value={"Save In-app Message"}
                                      disabled={
                                        updatedMessagesFormat.app_message
                                          .length > 1000
                                      }
                                      className={"p-2 px-5"}
                                      onClick={() => {
                                        setIsEditingInApp(false);
                                        setMessagesFormat({
                                          ...messagesFormat,
                                          app_message:
                                            updatedMessagesFormat.app_message,
                                        });
                                      }}
                                    ></Button>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </Card>
                      </div>
                    </Card>

                    <Card className="col-span-2 bg-secondary-sandGrey">
                      <div className="col-span-3 h-full">
                        <div className="font-bold text-black text-lg  ">
                          Variables:
                        </div>
                        <OrderList
                          className="w-full h-full"
                          itemTemplate={itemTemplate}
                          header=""
                          value={variables}
                          pt={{
                            controls: { className: "hidden" },
                          }}
                          onClick={(e) => {
                            const selectedVariable = e.target.textContent;
                            // console.log({ selectedVariable });
                            setSelectedVariable((prevSelectedVariables) => [
                              ...prevSelectedVariables,
                              selectedVariable,
                            ]);
                          }}
                          // value={MESSAGE_VARIABLES}
                        ></OrderList>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div className="w-full px-9">
            <Divider className=" border border-gray-200 px-11"></Divider>
          </div>
          <div>
            <div className="px-[1.25rem]">
              {/* <div className="font-bold text-black text-lg  ">Others:</div> */}

              <div className="px-2 grid grid-cols-12">
                <div className="col-span-6">
                  <div className="grid grid-cols-12">
                    <label className="col-span-4 ">Remarks:</label>
                    <div className="col-span-8">
                      <Textarea
                        className="w-full"
                        rows={5}
                        onChange={handleChange}
                        name={"remarks"}
                        value={behavioralVars.remarks}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-2 py-3">
            <div className="col-span-5"></div>
            <Button
              className={
                "p-2 font-normal mx-auto border bg-white border-primary-primaryYellow px-3"
              }
              value={"Cancel"}
              onClick={() => setOpenCancelModal(true)}
            />
            <Button
              className={"p-2 mx-auto px-5"}
              value={"Save"}
              disabled={!changesMade}
              onClick={() => validateFields()}
            />
          </div>
        </div>

        <Modal
          icon={`${process.env.PUBLIC_URL}/assets/images/error.png`}
          title="Cancel Changes"
          message="Are you sure you want to cancel all changes?"
          open={openCancelModal}
          actions={
            <div className="grid grid-cols-2 gap-2">
              <Button
                onClick={() => {
                  setOpenCancelModal(false);
                  setActiveSubItem(activeSubItem);
                  setPendingNavigation(null);
                }}
                value={"No"}
                className={"p-2"}
              />
              <Button
                onClick={() => {
                  if (pendingNavigation) {
                    navigate(pendingNavigation);
                    setPendingNavigation(null);
                    setChangesMade(false);
                  } else {
                    navigate(`/mbox-behavioral-campaigns/`);
                  }
                }}
                value={"Yes"}
                className={"p-2"}
              />
            </div>
          }
        />
        {/* </div> */}

        {/* Modal for removing confirmation */}
        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
      </ContentContainer>
    </>
  );
};

export default AddBehavioralCampaign;
